import { motion } from "framer-motion";
import { TECH_SPECS } from "../../data/finishes";

export default function SpecsBand() {
  return (
    <section data-testid="specs-band" className="bg-ink text-bone py-24 lg:py-32">
      <div className="max-w-[1600px] mx-auto px-5 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 border-b border-bone/15 pb-10 mb-14"
        >
          <div>
            <p className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.35em] text-beige mb-6">Engineering honesty</p>
            <h2 className="font-serif tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl">
              Beautiful by nature. <em className="italic text-beige">Exact by design.</em>
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-bone/60 lg:text-right lg:pb-2">
            We publish our material limits alongside our designs — because a panel that stays flat for
            twenty years is the real luxury.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          {TECH_SPECS.map((s, i) => (
            <motion.div
              key={s.t}
              data-testid={`specs-band-item-${i}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="border-t border-bone/20 pt-6"
            >
              <p className="font-mono text-[10px] tracking-[0.3em] text-beige mb-4">0{i + 1}</p>
              <h3 className="font-serif text-xl mb-3">{s.t}</h3>
              <p className="text-[13px] leading-relaxed text-bone/55">{s.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
